import { IVariation } from '~/lib/data-contract';

import styles from './productPickerGrid.module.css';

import { ProductPickerGridItem } from '../ProductPickerGridItem/ProductPickerGridItem';
import { ProductPickerTrackType } from '../ProductPickerTrack/ProductPickerTrack';

export type ProductPickerGridProps = {
	variants: IVariation[];
	type: ProductPickerTrackType;
	onVariationClick: (variation: IVariation) => void;
	setOpen: (isOpen: boolean) => void;
};
export const ProductPickerGrid = ({ variants, type, onVariationClick, setOpen }: ProductPickerGridProps) => (
	<div className={styles.root}>
		<ul className={styles.inner}>
			{variants.map((variant) => (
				<ProductPickerGridItem
					variant={variant}
					onVariationClick={onVariationClick}
					setOpen={setOpen}
					type={type}
				/>
			))}
		</ul>
	</div>
);
